import React, { useEffect, useState } from 'react';
// import Logo from '../assets/images/img/s26-logo.jpeg';
// import brandVideo from '../assets/images/video/s26-video.mp4';

const BrandS26 = () => {
  const [platform, setPlatform] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      setPlatform('android');
      window.location.href = 'https://rst.spatialgrid.ai/s26/index.html';
    } else if (isIOS) {
      setPlatform('ios');
      // Start countdown for iOS users
      // const timer = setInterval(() => {
      //   setCountdown((prev) => {
      //     if (prev <= 1) {
      //       clearInterval(timer);
            window.location.href = 'https://rst.spatialgrid.ai/s26/index.html';
      //       return 0;
      //     }
      //     return prev - 1;
      //   });
      // }, 1000);

      // return () => clearInterval(timer);
    } else {
      setPlatform('unsupported');
    }
  }, []);

  return (
    <div className="min-h-screen max-h-screen  bg-black text-white relative">
      {/* Header */}
      

      {/* Center Content */}
      <div className={`min-h-screen relative  flex flex-col gap-4 items-center pt-4 px-8 ${platform === 'ios' ? 'justify-center' : ''}`}>
        {/* Coming Soon Text - Only for Android */}
        {platform === 'android' && (
          <div className="text-center relative ">
            <h1 className="text-lg md:text-xl lg:text-2xl font-light tracking-tight mb-2 text-white">
              Coming Soon
            </h1>
            <div className="w-16 h-px bg-gray-600 mx-auto"></div>
          </div>
        )}

        {/* iOS Redirect Message */}
        {platform === 'ios' && (
          <div className="text-center relative top-[-2vw] xl:top-[8vw] mb-4">
            <h1 className="text-lg md:text-xl lg:text-2xl font-light tracking-tight mb-2 text-white">
              Redirecting to App...
            </h1>
            <p className="text-sm text-gray-400">
              Redirecting in {countdown} seconds
            </p>
            <div className="w-16 h-px bg-gray-600 mx-auto mt-4"></div>
          </div>
        )}

        {/* Unsupported Platform Message */}
        {platform === 'unsupported' && (
          <div className="text-center relative top-[-2vw] xl:top-[8vw]">
            <h1 className="text-lg md:text-xl lg:text-2xl font-light tracking-tight mb-4 text-white">
              Unsupported Platform
            </h1>
            <div className="w-16 h-px bg-gray-600 mx-auto"></div>
          </div>
        )}

        {/* Video Container */}
        {platform !== 'ios' && (
          <div className="w-full">
            <div className="relative flex justify-center min-h-full rounded-lg shadow-2xl">
              <video
                className=" h-[80vh]"
                autoPlay
                loop
                muted
                playsInline
              >
                <source
                  src=''
                  type="video/mp4"
                  className="min-w-[250px]"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
                  <span className="text-gray-500 text-sm">
                    Video not supported
                  </span>
                </div>
              </video>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandS26;
